export const setOutdatedAction = (state, action) => {
    const outdated = action.payload;

    return {
        ...state,
        outdated,
    };
};

export const setUpdatedAction = (state, action) => {
    const updated = action.payload;

    return {
        ...state,
        updated,
    };
};

export const setErroredEntitiesAction = (state, action) => {
    const erroredEntities = action.payload;

    return {
        ...state,
        erroredEntities,
    };
};
export const unsetSelectedClassificationAction = (state, action) => {
    const unsetSelectedClassification = action.payload;
    return {
        ...state,
        unsetSelectedClassification,
    };
};

export const replaceRaceConditionsAction = (_state, action) => {
    const newState = action.payload;
    return { ..._state, newState };
};
